import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

/**
 * Returns a disabledDate function for items with application_date and end_date.
 * Shared by general-condition and subscription-price createUpdateDrawer fields.
 * @function
 * @param {Object[]} items - List of items with date ranges (application_date, end_date, _id).
 * @param {string} purpose - 'create' or 'update'.
 * @param {Object} [itemToEdit] - When purpose is 'update', the item being edited (excluded from ranges).
 * @returns {Function} disabledDate function (current) => boolean.
 */
export const createDisabledDateForRanges =
  (items, purpose, itemToEdit) => (current) => {
    let isDisabled = false;
    const list =
      purpose === 'create'
        ? items
        : items.filter((el) => el._id !== itemToEdit?._id);
    list.forEach(({ application_date, end_date }) => {
      if (
        dayjs(current) >= dayjs(application_date).startOf('day') &&
        dayjs(current) <= dayjs(end_date).endOf('day')
      ) {
        isDisabled = true;
      }
    });
    return isDisabled;
  };

/**
 * Returns a Form field config for a date range field (DatePicker with disabled dates in red).
 *
 * @param {string[]} name - Field name, e.g. ['application_date'] or ['end_date'].
 * @param {function} disabledDate - disabledDate function from createDisabledDateForRanges.
 * @returns {Object} - Field config { name, rules, input }.
 */
export const createDateRangeField = (name, disabledDate) => ({
  name,
  rules: [{ required: true }],
  input: (
    <DatePicker
      disabledDate={disabledDate}
      dateRender={(current) => {
        const isDisabled = disabledDate(current);
        return isDisabled ? (
          <div style={{ color: 'red' }}>{current.date()}</div>
        ) : (
          current.date()
        );
      }}
    />
  )
});
